import { ENV, BREATHE_DOMAIN } from "../constants";

const APP_PORTS = {
  hr: 3000,
  saas: 3000,
  rota: 9000,
  login: 8000,
  rta: 3001,
};

const appUrl = (app) => {
  if (ENV !== "development") {
    return `https://${app}.${BREATHE_DOMAIN}`;
  }
  return `http://${app}.${BREATHE_DOMAIN}:${APP_PORTS[app]}`;
};

const moduleUrl = (envVarName) => {
  return process.env[envVarName];
};

export const APPLICATIONS_METADATA = {
  hr: {
    name: "HR",
    description: "Our core HR system",
    url: appUrl("hr"),
  },
  rta: {
    name: "Rota",
    description: "Time and attendance",
    url: moduleUrl("REACT_APP_RTA_URL"),
  },
  "partner-hub": {
    name: "Partner Hub",
    description: "Manage your clients",
    url: `${appUrl("hr")}/partner_company`,
  },
  saas: {
    name: "Administration",
    description: "Configure Breathe",
    url: `${appUrl("hr")}/saas_admins`,
  },
};

export const APPLICATIONS = APPLICATIONS_METADATA;
